import PropTypes from "prop-types";
import InputBase from "./InputBase";
import InputText from "./InputText";

/**
 * In dieser Klasse wenn das Feld nicht aktiviert ist, dann wird der Text des defaultValue angezeigt
 */
class InputLink extends InputBase {

  getValue() {
    if (this.props.disabled) {
      return this.props.defaultValue.text;
    }
    return this.inputElementRef.current.getValue();
  }

  setError(message) {
    if (this.inputElementRef.current) {
      // Direkt setState auf InputText aufrufen, OHNE dessen onErrorChange zu triggern,
      // da InputLink selbst den Callback mit der eigenen _id auslöst.
      this.inputElementRef.current.setState({errorText: message || ''});
    }
    this.props.onErrorChange?.(this._id, true);
  }

  clearError() {
    if (this.inputElementRef.current) {
      this.inputElementRef.current.setState({errorText: ''});
    }
    this.props.onErrorChange?.(this._id, false);
  }

  onBlur(value) {
    if (this.inputElementRef.current) {
      this.inputElementRef.current.onBlur(value);
    }
  }

  render() {
    let {disabled, defaultValue = null, size, labelElement} = this.props;
    let link, text;
    if (defaultValue) {
      link = defaultValue.href;
      text = defaultValue.text;
    }

    return <InputText
      labelElement={labelElement}
      fullWidth
      size={size}
      disabled={disabled}
      defaultValue={disabled ? text : link}
      constrains={this.constrains}
      ref={this.inputElementRef}/>
  }
}

InputLink.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  labelElement: PropTypes.string,
  helpTextElement: PropTypes.node,
  defaultValue: PropTypes.shape({
    href: PropTypes.string, text: PropTypes.string
  }),
  onChange: PropTypes.func
}
export default InputLink;
